import { useAuthenticatedImage } from '../../../hooks/useAuthenticatedImage';

interface PhotoThumbnailItemProps {
    photoId: number;
    description: string | null | undefined;
    onClick: () => void;
}

/**
 * Photo thumbnail grid item with authenticated image loading
 * Fetches thumbnail via axios with automatic token refresh on 403
 */
export default function PhotoThumbnailItem({ photoId, description, onClick }: PhotoThumbnailItemProps) {
    const thumbnailUrl = `/photos/${photoId}/stream?thumb=true`;
    const { src: thumbnailSrc, loading: thumbnailLoading } = useAuthenticatedImage(thumbnailUrl);

    return (
        <div
            className="mosaic-item"
            onClick={onClick}
            style={{
                position: 'relative',
                overflow: 'hidden',
                background: thumbnailLoading ? 'rgba(0, 0, 0, 0.2)' : 'transparent',
            }}
        >
            {thumbnailLoading && (
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'rgba(0, 0, 0, 0.3)',
                    color: 'var(--text-primary)',
                    fontSize: '0.75rem',
                    zIndex: 1,
                }}>
                    Loading...
                </div>
            )}
            {thumbnailSrc && (
                <img
                    src={thumbnailSrc}
                    alt={description || 'Family moment'}
                    loading="lazy"
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                    }}
                />
            )}
        </div>
    );
}
